<template>
  <div
    :id="id"
    :isSelected="getSelected"
    class="card"
    :class="{ selected: getSelected }"
    :draggable="draggable"
    :clickable="clickable"
    @dragstart="dragStart"
    @dragover.stop
    @dragenter.stop
    @dragend="dragEnd"
    @click.prevent="clickSelect"
    :category="category"
    :value="value"
    :output="output"
    @mousedown="setMouseDown"
    @mousemove="checkForMove"
    @mouseup="resetDrag">

    <slot />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: ['id','draggable', 'clickable', 'category', 'value', 'numberSelected', 'limit', 'output', 'title'],
  data() {
    return {
      isSelected: this.$store.state.selectedValues[this.category].includes(this.output) || this.$store.state.selectedValues[this.category] === this.output ? true : false, // If this.output ===
      selectedValues: this.$store.state.selectedValues,
      mouseMoved: false,
      mouseDown: false,
    }
  },
  methods: {
    ...mapMutations([
      'mergeData',
      'set'
    ]),
    storeValues() {
      const cardValues = {
        [this.id]: {
          category: this.category,
          isSelected: this.isSelected,
          value: this.value,
          output: this.output,
          title: this.title
        }
      }

      this.mergeData(cardValues)
    },
    dragStart(e) {
      e.dataTransfer.setData('card_id', this.id);

      this.$store.state.isSelected = this.isSelected;
    },
    dragEnd() {
      this.isSelected = this.$store.state.isSelected;
      this.$emit('drag-end', this.id);
      this.storeValues();
      this.set(this.category)
    },
    setMouseDown() {
      this.mouseDown = true;
    },
    checkForMove() {
      setTimeout(() => {
      if (this.mouseDown) {
        this.mouseMoved = true;
      }
      }, 100)
    },
    resetDrag() {
      this.mouseDown = false;
      this.mouseMoved = false;
    },
    clickSelect() {
      if (this.clickable && !this.mouseMoved) {
        // if limit then else run as usual
        if ((typeof this.limit === 'undefined') || this.numberSelected < this.limit || this.isSelected) {
          this.isSelected = !this.isSelected; 
        
          this.storeValues();
          this.set(this.category)

          this.$emit('click-selected', this.isSelected)
          this.$emit('radio-selected', this.id)
        }
      }
    },
  },
  computed: {
    getSelected() {
      if (this.$store.state.selectedValues[this.category]) {
        if (this.$store.state.selectedValues[this.category].includes(this.output)) {
          return true;
        } else if (this.$store.state.selectedValues[this.category] === this.output) {
          return true;
        } else {
          return false;
        }
      } else if (this.$store.state.selectedValues[this.category] === "" && this.output === "Other") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.isSelected) {
      this.$emit('click-selected', this.isSelected)
      this.storeValues();
    }
  }
}
</script>

<style scoped>
  .card {
    margin-bottom: 0;
    padding-bottom: 0;
    transition: transform 200ms ease;
    border: 4px solid transparent;
    position: relative;
  }

  .card[clickable] {
    cursor: pointer;
  }

  .card[draggable] {
    cursor: grab;
  }

  h1 {
    text-align: center;
  }

  .card.selected {
    opacity: 0.8;
    border: 4px solid #69BF4A;
  }

  .card.selected::after {
    content: '';
    background-color: #69BF4A;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: hover 0.3s;
    animation-fill-mode: forwards;
  }

  .card::before {
    content: '';
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 100;
  }

  .card.selected::before {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='check' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' class='svg-inline--fa fa-check fa-w-16 fa-7x'%3E%3Cpath fill='%2369BF4A' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z' class=''%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    width: 70%;
    height: 70%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    animation: hover-checkmark 0.3s;
    animation-fill-mode: forwards;
    transition: opacity 0.4s ease;
  }

  @keyframes hover {
    from {
      opacity: 0;
    }

    to {
      opacity: 0.2;
    }
  }

  @keyframes hover-checkmark {
    from {
      opacity: 0;
    }

    to {
      opacity: 0.8;
    }
  }
</style>